<template>
  <div>
    <interaction-hint v-if="!readonly">
      <span class="hidden-md-and-up">
        Переставьте в правильном порядке
      </span>
      <span class="hidden-sm-and-down">
        Переставьте варианты в правильном порядке, перетаскивая блоки мышью
      </span>
    </interaction-hint>
    <draggable :value="optionsList" :options="sortableOptions" @input="sorted">
      <div
        class="answer my-3"
        v-for="(item, index) in optionsList"
        :key="index"
      >
        <v-layout align-center>
          <v-icon v-if="!readonly" class="sort-handle">
            reorder
          </v-icon>
          <label class="ml-2" :disabled="readonly">
            {{ item.option }}
          </label>
        </v-layout>
      </div>
    </draggable>
  </div>
</template>
<style>
label[disabled] {
  cursor: no-drop !important;
}
.sort-handle {
  cursor: pointer;
}
</style>
<script type="text/babel">
import InteractionHint from './InteractionHint'
import draggable from 'vuedraggable'
export default {
  name: 'InteractionSequence',
  props: {
    items: {
      type: [Array, Object],
      required: true
    },
    value: {
      required: true
    },
    readonly: {
      default: false
    }
  },
  computed: {
    sortableOptions() {
      return {
        handle: '.sort-handle'
      }
    },
    sequence() {
      if (this.value) {
        return String(this.value)
          .split(',')
          .map(e => Number(e))
      } else {
        let result = []
        for (let i = 0; i < this.items.length; i++) {
          result.push(i + 1)
        }
        result.sort(() => {
          return 0.5 - Math.random()
        })
        return result
      }
    },
    optionsList() {
      if (Array.isArray(this.items)) {
        let unsorted = this.items.map((e, index) => {
          const c = { ...e }
          c.key = index + 1
          return c
        })
        let sorted = []
        this.sequence.forEach(index => {
          sorted.push(unsorted[index - 1])
        })
        return sorted
      } else {
        return []
      }
    }
  },
  methods: {
    sorted(value) {
      let result = value.map(e => e.key).join(',')
      this.$emit('input', result)
    }
  },
  components: {
    draggable,
    InteractionHint
  }
}
</script>
